<template>
  <div
    v-if="shouldRenderConfig"
    ref="preview2D"
    :class="[getClassName + 'Container', visible]"
  >
    <img :src="getPreview2D" />
  </div>
</template>
<script>
import { usePreview2DStore } from "@/stores/modules/preview2D";
import { mapState, mapActions } from "pinia";

export default {
  computed: { ...mapState(usePreview2DStore, ["getPreview2D"]) },
  props: ["visible"]
};
</script>
